import React, {FC} from 'react';
import { inputProps as InputProps } from '../../types/types';

interface SelectInputProps extends InputProps {
    value: string,
    options: { [value: string]: string } // options['value'] === 'Text to display' (pre-translated)
}

const SelectInput: FC<SelectInputProps> = ({
    value,
    options,
    label,
    labelText,
    onChange,
    required,
    redHighlight,
    additionalClassNames,
    additionalNote,
    inputDisabled,
}) => {

    return (
        <div className={
            "mb-3 w-full " + (additionalClassNames ?? "")
            + (redHighlight ? " required-highlight" : "").replace("  ", " ")}
        >
            <label htmlFor={label}
                    className="form-check-label inline-block text-gray-800">
                {labelText}
                {required &&
                    <span className="text-red-500 font-bold text-2xl">*</span>
                }
            </label>
            <select
                value={value}
                id={label}
                name={label}
                className="form-select appearance-none
                    block
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding bg-no-repeat
                    border border-solid border-orange-200
                    rounded
                    m-0
                    focus:text-gray-700
                    focus:bg-white
                    focus:border-orange-200
                    focus:shadow-none
                    focus:outline-none
                "
                disabled={inputDisabled}
                onChange={onChange} >
                {Object.keys(options).map((key: string) => {
                    return <option key={key}
                                   value={key}>{options[key]}</option>
                })}
            </select>
            {additionalNote !== undefined && <p>{additionalNote}</p>}
        </div>
    );
};

export default SelectInput;